import { Spin } from 'aa_common/front-end/antd'
import { MainHeader } from 'aa_common/front-end/components'
import { Col, Layout, Row } from 'antd'
import classNames from 'classnames'
import { BreadcrumbNavigation } from 'components/molecules'
import TopMessage from 'components/organisms/app/TopMessage'
import MainMenu from 'components/organisms/MainMenu'
import React from 'react'

import {
  ActionWrapper,
  Body,
  BreadcrumbArea,
  FilterPanel,
  Header,
  MainTemplateLayout,
  SiteLayout,
  TopMessage as TopMessageWrapper,
  Wrapper,
} from './styles'

export interface MainTemplateProps {
  header?: React.ReactNode
  sidebar?: React.ReactNode
  breadcrumb?: React.ReactNode
  actions?: React.ReactNode
  topMessage?: React.ReactNode
  filterPanel?: React.ReactNode
  containerClassName?: string
  bodyLayoutClassName?: string
  isLoadingApp?: boolean
}

const MainTemplate: React.FC<MainTemplateProps> = ({
  children,
  containerClassName,
  bodyLayoutClassName,
  filterPanel,
  header,
  sidebar,
  breadcrumb,
  actions,
  topMessage,
  isLoadingApp = false,
}) => {
  return (
    <Wrapper id="app-content-wrapper">
      <Layout>
        <Header>{header}</Header>
        <Body>
          {sidebar}
          <MainTemplateLayout className={bodyLayoutClassName} id="app-main-body">
            {breadcrumb && (
              <BreadcrumbArea
                className={classNames({
                  'has-search-panel': !!filterPanel,
                })}
              >
                <Row justify="space-between" align="middle" wrap={false}>
                  <Col flex="1 1 auto" style={{ minWidth: 0, overflow: 'hidden' }}>
                    {breadcrumb}
                  </Col>
                  {actions && (
                    <Col flex="0 0 auto" style={{ display: 'flex', alignItems: 'center', marginLeft: '16px' }}>
                      <ActionWrapper>{actions}</ActionWrapper>
                    </Col>
                  )}
                </Row>
                {filterPanel && <FilterPanel>{filterPanel}</FilterPanel>}
              </BreadcrumbArea>
            )}
            <TopMessageWrapper>{topMessage}</TopMessageWrapper>
            <SiteLayout className={containerClassName}>
              <Spin loading={isLoadingApp}>{children}</Spin>
            </SiteLayout>
          </MainTemplateLayout>
        </Body>
      </Layout>
    </Wrapper>
  )
}

MainTemplate.defaultProps = {
  header: <MainHeader />,
  sidebar: <MainMenu subMenuContainerId="app-content-wrapper" />,
  breadcrumb: <BreadcrumbNavigation sectionName="Home" />,
  actions: undefined,
  topMessage: <TopMessage />,
  filterPanel: null,
}

export default MainTemplate
